<template lang="html">
<div class="navBarContent" :style="{ background: background }">
  <div class="placeHolder"></div>
    <div class="navBar"  :style="{ background: background }">
        <div class="navItem">
            <div v-if='showButtons'>
                <div class="navButtons">
                    <div class="goBackBtn" @click="goBack"></div>
                    <div v-if="showHomeBtn">
                        <div class="goHomeBtn" @click="goHome"></div>
                    </div>
                </div>
            </div>
            <div v-if='showLocation'>
                <div class="locationBox" @click="goSearchCity">
                    <div class="locationTxt overflowEllipsis" v-text="locationTxt"></div>
                    <img class="speciesIcon" src="/img/select3x.png"></img>
                </div>
            </div>
        </div>
        <div class="navItem navBarTitle" :style="{ color: navBarTitleColor }" v-text="navBarTitle"></div>
        <div class="navItem"></div>
    </div>
</div>
</template>

<script>
export default {
    name: 'CustomNav',
    props: {
        background: {
            type: String,
            default: '#ffffff',
        },
        showButtons: {
            type: Boolean,
            default: false,
        },
        showHomeBtn: {
            type: Boolean,
            default: false,
        },
        showLocation: {
            type: Boolean,
            default: false,
        },
        locationTxt: {
            type: String,
            default: '',
        },
        navBarTitleColor: {
            type: String,
            default: '#000000',
        },
        navBarTitle: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            publicPath: process.env.BASE_URL,
        };
    },
    methods: {
        goBack() {
            this.$router.go(-1);
        },
        goHome() {
            this.$router.push('/');
        },
        goSearchCity() {
            this.$router.push('/search');
        },
    },
};
</script>

<style lang="css" scoped>
.navBarContent{
  overflow: hidden;
}

.navBar{
  position: fixed;
  top: 0;
  width: 100%;
  max-width: 768px;
  height: 4rem;
  line-height: 4rem;
  text-align: left;
  box-sizing: content-box;
  display: flex;
  align-items: center;
  justify-content: space-around;
  z-index: 9999;
}
.placeHolder{
  height: 4rem;
}
.android {
  height: 4rem;
}
.navItem{
  flex: 1;
  text-align: center;
}
.navBarTitle{
  font-size: 17px;
}
.navButtons{
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding-left: 7px;
}
.navButtons div{
  width: 27px;
  height: 27px;
  background-repeat: no-repeat;
  background-position: center;
}
.goBackBtn {
  background-repeat: no-repeat;
  background-position: center;
  background-size: 17px;
  background-image: url("data:image/png;base64,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")
}
.goHomeBtn {
  margin-left: 10px;
  background-size: 26px;
  background-repeat: no-repeat;
  background-position: center;
  background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAYAAADDPmHLAAAFGUlEQVR4Xu2d4ZENQRSF70ZACESACBCBEgEiQASIABEgAyJABIiAjQARUGe9qVq8fT1vbt/u231OV23V/uieN/fcb053z0z3nJgKtQIn1NEreBMA5BAIAAFArgB5+HIAAUCuAHn4cgABQK4AefhyAAFArgB5+HIAAUCuAHn4cgABQK4AefhyAAFArgB5+HIAAUCuAHn4cgABQK4AefjMDnDZzK7t8n9qZt8YWWAD4IqZPTGzW2aG/8+XH2b21szemNkHFhhYAMDV/tzM7q9MLAC4a2aAYurCAACS/97Mrh+ZSST/tpl9PrLdUNVnB2Br8pckTg/BzAB4k08BwawA1Er+9BDMCEDt5E8NwWwARCX/PARXZ5odzARAdPIXCDArwOxgiiniTAC8OmKe752qTQPBLAC0TP5UTjADAD2SPw0EowPQM/lTQDAyABmSPzwEowKQKfkLBK/N7IF3dNm6/YgAPN090m2t1ZrfGw6C0QDA41xc/ZnLUBCMBMAIyR+uOxgFgJGSPxQEIwAwYvKHgSA7ACMnf4HgmZlh4JqyZAZghuQvScf0EIPDdCUrAHh/D+/x4QnfLCUlBBkBmDH5aZ0gGwAzJz8lBJkAYEh+OgiyAMCU/FQQZACAMfmAIMWag94AYJT/dbLR/jGzlu4Q9ASg1UucxySkR92uEPQCQMn/G7VuEPQAQMnf7zNdIGgNgJJ/uJNpDkFLAJT8dSMM7FRyo9XCk1YAKPnrkr/UarbwpBUAGV/iPC4l7Ws3gaAFAEr+dnjCIYgG4IWZPdwev1ruNq7CfkUhJRIA3OL9FHLWfAcNe5cgEgBsuXaHL1chEWNmgH0JqpcoADDq/179bLkPiKlh9R3LogDARox4pUulngKPzQxjqqpFAFSVM/RgIW8XRwGgLqA+C0N1AQgfr0Hfq68D5RG/bNjpdJVQUQ6AH4cLYM/dZUfuVSekSv8p8HO3uXX1ASB+KRKABQIMXOQE28h+Z2aPIreyjwbgfNiYGewrAITVJWDtSPC+gis+fCu6lgBcdA2gm7i57QIZvtXHnb13C0QAdJP+7IcFwG6gKAfoBKIcoJPwu5+VAzRyAAy2MKha+2EofE8If9HOJAAaAOC5hRr9TEMANAAAO3t7vgL2K7CXEAAC4OwTdt0KwyBQDnAALwFQvvbUBZQ1ctWIvhMoB5ADaBB4EQPqAsrmpS6grJGrhroAl3y+xnKAsn5ygLJGrhpyAJd8vsZygLJ+coCyRq4acgCXfL7GcoCyfnKAskauGnIAl3y+xnKAsn5ygLJGrhpyAJd8vsZygLJ+coCyRq4acgCXfL7GcoCyfnKAskauGtGLSPU4+EB6MjhA9KdgBUByAKK/DpYZgJcH1ga6bHVt4wwOgPfv8c2AqJIZAGz/hs20upUMACB4LNqIWiGcFQCs+wf84SuAD9GVBYDIbiArAJ4FK9UcIwsAkS6QEYAUVz9EzwQA7BBdwaVqeP85UEYAvOdUTaJMACAobC+LO4M1IfCKXftGUNi2r1uoyAbAAgFuDtUaFGYB4HQ35es66v8XkowALOeIvXMwOPSC0BsAJB5AYy+kriP+fQ6RGYDlfJe1+lscbhlceoT3LN7EfgRr9yTYGp+r3QgAuAJU48MKCAByQgSAACBXgDx8OYAAIFeAPHw5gAAgV4A8fDmAACBXgDx8OYAAIFeAPHw5gAAgV4A8fDmAACBXgDx8OYAAIFeAPHw5gAAgV4A8fDkAOQC/AdN1EZBHE/CWAAAAAElFTkSuQmCC");
}
.locationBox{
  flex: 1;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 15px;
  color: #2D2D2D;
  padding: 0 10px;

}
.locationBox img{
  width: 6px;
  height: 6px;
}
.down{
  transform: rotate(-180deg);
  -moz-transform: rotate(-180deg);
  -webkit-transform: rotate(-180deg);
  -o-transform: rotate(-180deg);
}
.locationTxt{
  font-family: PingFangSC-Medium;
  max-width: 90%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  word-spacing: normal;
  margin: 0 5px;
  font-size: 15px;
  color: #333333;
}
.overflowEllipsis{
  max-width: 6rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
